import { Filters } from './Filters';
import { Table } from './Table';

export const ReviewedTable = () => {
  return (
    <>
      <Filters />
      <Table />
    </>
  );
};
